import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const procedures = [
  {
    title: 'RTU de Próstata',
    description: 'La Resección Transuretral (RTU) de próstata es un procedimiento mínimamente invasivo para tratar la hiperplasia prostática benigna (HPB). Se realiza a través de la uretra sin necesidad de incisiones externas.',
    icon: 'ri-surgical-mask-line',
    duration: '60-90 minutos',
    anesthesia: 'Raquídea o general',
    recovery: '1-2 días hospitalización',
    benefits: [
      'Mejora inmediata de síntomas urinarios',
      'Sin incisiones externas',
      'Recuperación relativamente rápida',
      'Técnica bien establecida y segura'
    ],
    details: 'Se introduce un resectoscopio a través de la uretra para remover el tejido prostático que obstruye el flujo urinario. Es el tratamiento gold standard para próstatas de tamaño moderado a grande.'
  },
  {
    title: 'Litotricia Extracorporal',
    description: 'Procedimiento no invasivo que utiliza ondas de choque para fragmentar cálculos renales y ureterales, permitiendo su eliminación natural a través de la orina.',
    icon: 'ri-sound-module-line',
    duration: '30-60 minutos',
    anesthesia: 'Sedación consciente',
    recovery: 'Ambulatorio',
    benefits: [
      'Procedimiento ambulatorio',
      'Sin incisiones ni instrumentación',
      'Mínimas molestias post-procedimiento',
      'Alta tasa de éxito en cálculos &lt;2cm'
    ],
    details: 'Las ondas de choque se enfocan precisamente en el cálculo utilizando fluoroscopia o ultrasonido. Los fragmentos resultantes son eliminados naturalmente por la orina en días o semanas.'
  },
  {
    title: 'Vasectomía',
    description: 'Método anticonceptivo masculino permanente y altamente efectivo. Se seccionan los conductos deferentes para impedir el paso de espermatozoides.',
    icon: 'ri-scissors-cut-line',
    duration: '20-30 minutos',
    anesthesia: 'Local',
    recovery: '2-3 días',
    benefits: [
      'Efectividad &gt;99%',
      'Procedimiento ambulatorio',
      'Sin efectos hormonales',
      'Técnica sin bisturí disponible'
    ],
    details: 'Se realiza mediante técnica sin bisturí, utilizando instrumental especializado para minimizar trauma tisular. Incluye consulta preoperatoria obligatoria y seguimiento post-quirúrgico.'
  },
  {
    title: 'Implante de Prótesis de Pene',
    description: 'Solución definitiva para disfunción eréctil severa que no responde a otros tratamientos. Proporciona rigidez suficiente para actividad sexual satisfactoria.',
    icon: 'ri-heart-add-line',
    duration: '45-90 minutos',
    anesthesia: 'Raquídea o general',
    recovery: '4-6 semanas',
    benefits: [
      'Solución permanente',
      'Resultados naturales',
      'Alta satisfacción del paciente',
      'Discreción total'
    ],
    details: 'Disponemos de prótesis inflables y maleables. Se colocan en los cuerpos cavernosos del pene. Requiere evaluación psicosexual previa y seguimiento especializado.'
  },
  {
    title: 'Biopsia de Próstata',
    description: 'Procedimiento diagnóstico guiado por ultrasonido transrectal para obtener muestras de tejido prostático y detectar cáncer de próstata.',
    icon: 'ri-test-tube-line',
    duration: '15-30 minutos',
    anesthesia: 'Local + sedación',
    recovery: 'Ambulatorio',
    benefits: [
      'Diagnóstico preciso',
      'Guiada por imagen en tiempo real',
      'Mínimas molestias',
      'Resultados en 7-10 días'
    ],
    details: 'Se toman múltiples muestras sistemáticas guiadas por ultrasonido. Incluye profilaxis antibiótica y preparación intestinal previa. Fundamental para diagnóstico temprano.'
  },
  {
    title: 'Circuncisión',
    description: 'Procedimiento quirúrgico para remover el prepucio del pene. Indicado en casos de fimosis, parafimosis o por motivos médicos específicos.',
    icon: 'ri-scissors-line',
    duration: '30-45 minutos',
    anesthesia: 'Local o general',
    recovery: '1-2 semanas',
    benefits: [
      'Mejora higiene genital',
      'Reduce riesgo de infecciones',
      'Soluciona fimosis/parafimosis',
      'Técnica ambulatoria'
    ],
    details: 'Se utiliza técnica de sutura absorbible para óptima cicatrización. Incluye cuidados post-operatorios detallados y seguimiento hasta cicatrización completa.'
  },
  {
    title: 'Uretrotomía Interna',
    description: 'Tratamiento para estrecheces uretrales mediante sección endoscópica de la cicatriz que causa la obstrucción al flujo urinario.',
    icon: 'ri-knife-line',
    duration: '20-40 minutos',
    anesthesia: 'Raquídea',
    recovery: '1 día hospitalización',
    benefits: [
      'Procedimiento mínimamente invasivo',
      'Mejora inmediata del flujo',
      'Sin incisiones externas',
      'Recuperación rápida'
    ],
    details: 'Se introduce un uretrotomo por la uretra para seccionar la estenosis bajo visión directa. Requiere sonda vesical temporal y seguimiento urodinámico posterior.'
  },
  {
    title: 'Nefrolitotomía Percutánea',
    description: 'Procedimiento mínimamente invasivo para extraer cálculos renales grandes o complejos a través de un pequeño túnel creado en la espalda.',
    icon: 'ri-capsule-line',
    duration: '2-4 horas',
    anesthesia: 'General',
    recovery: '2-3 días hospitalización',
    benefits: [
      'Para cálculos grandes (&gt;2cm)',
      'Alta tasa de eliminación completa',
      'Menor morbilidad que cirugía abierta',
      'Técnica gold standard'
    ],
    details: 'Se crea un túnel de trabajo de 1cm hacia el riñón. Los cálculos se fragmentan y extraen completamente. Incluye nefrostomía temporal y seguimiento imagenológico.'
  }
];

export default function Procedures() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-br from-[#0B2A4A] to-[#1B84FF] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">
              Procedimientos Especializados
            </h1>
            <p className="text-xl md:text-2xl text-blue-100 max-w-4xl mx-auto mb-8">
              Ofrecemos procedimientos urológicos de vanguardia con tecnología de última generación 
              y el más alto estándar de atención médica
            </p>
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-6 max-w-3xl mx-auto">
              <div className="flex items-center justify-center text-white/90">
                <i className="ri-shield-check-line text-2xl mr-3"></i>
                <p className="text-lg">
                  <strong>Garantía de calidad:</strong> Todos nuestros procedimientos siguen protocolos internacionales 
                  y se realizan con equipos de última tecnología
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Procedures Grid */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {procedures.map((procedure, index) => (
              <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300">
                <div className="p-8">
                  <div className="flex items-start mb-6">
                    <div className="w-16 h-16 bg-[#0B2A4A]/10 rounded-full flex items-center justify-center mr-6 flex-shrink-0">
                      <i className={`${procedure.icon} text-2xl text-[#0B2A4A]`}></i>
                    </div>
                    <div>
                      <h3 className="text-2xl font-bold text-[#111317] mb-2">
                        {procedure.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed">
                        {procedure.description}
                      </p>
                    </div>
                  </div>

                  {/* Procedure Details */}
                  <div className="grid grid-cols-3 gap-4 mb-6 p-4 bg-gray-50 rounded-lg">
                    <div className="text-center">
                      <i className="ri-time-line text-[#1B84FF] text-xl mb-1"></i>
                      <p className="text-sm font-semibold text-[#111317]">Duración</p>
                      <p className="text-xs text-gray-600">{procedure.duration}</p>
                    </div>
                    <div className="text-center">
                      <i className="ri-syringe-line text-[#1B84FF] text-xl mb-1"></i>
                      <p className="text-sm font-semibold text-[#111317]">Anestesia</p>
                      <p className="text-xs text-gray-600">{procedure.anesthesia}</p>
                    </div>
                    <div className="text-center">
                      <i className="ri-home-heart-line text-[#1B84FF] text-xl mb-1"></i>
                      <p className="text-sm font-semibold text-[#111317]">Recuperación</p>
                      <p className="text-xs text-gray-600">{procedure.recovery}</p>
                    </div>
                  </div>

                  {/* Benefits */}
                  <div className="mb-6">
                    <h4 className="text-lg font-semibold text-[#111317] mb-3 flex items-center">
                      <i className="ri-check-double-line text-[#1B84FF] mr-2"></i>
                      Beneficios
                    </h4>
                    <ul className="grid grid-cols-1 md:grid-cols-2 gap-2">
                      {procedure.benefits.map((benefit, benefitIndex) => (
                        <li key={benefitIndex} className="flex items-center text-sm text-gray-700">
                          <i className="ri-check-line text-[#1B84FF] mr-2 flex-shrink-0"></i>
                          {benefit}
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Details */}
                  <div className="mb-6">
                    <h4 className="text-lg font-semibold text-[#111317] mb-3 flex items-center">
                      <i className="ri-information-line text-[#1B84FF] mr-2"></i>
                      Detalles del Procedimiento
                    </h4>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {procedure.details}
                    </p>
                  </div>

                  <div className="flex flex-col sm:flex-row gap-3">
                    <button className="flex-1 bg-gradient-to-r from-[#0B2A4A] to-[#1B84FF] text-white py-3 px-6 rounded-lg hover:from-[#1B84FF] hover:to-[#0B2A4A] transition-all duration-300 cursor-pointer whitespace-nowrap">
                      <i className="ri-calendar-check-line mr-2"></i>
                      Agendar Consulta
                    </button>
                    <button className="flex-1 border-2 border-[#0B2A4A] text-[#0B2A4A] py-3 px-6 rounded-lg hover:bg-[#0B2A4A] hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap">
                      <i className="ri-question-answer-line mr-2"></i>
                      Más Información
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Privacy Notice */}
      <section className="py-12 bg-[#0B2A4A]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white/10 backdrop-blur-sm rounded-xl p-8 text-center">
            <div className="flex items-center justify-center mb-4">
              <i className="ri-shield-check-line text-3xl text-white mr-3"></i>
              <h3 className="text-2xl font-bold text-white">Compromiso con la Privacidad</h3>
            </div>
            <p className="text-white/90 text-lg max-w-4xl mx-auto mb-6">
              En UROMÁS garantizamos la máxima confidencialidad en todos nuestros procedimientos. 
              Su privacidad y bienestar son nuestra prioridad absoluta.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-white/80">
              <div className="flex items-center justify-center">
                <i className="ri-lock-line text-xl mr-2"></i>
                <span>Confidencialidad Total</span>
              </div>
              <div className="flex items-center justify-center">
                <i className="ri-user-heart-line text-xl mr-2"></i>
                <span>Atención Personalizada</span>
              </div>
              <div className="flex items-center justify-center">
                <i className="ri-shield-user-line text-xl mr-2"></i>
                <span>Protección de Datos</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-[#111317] mb-6">
            ¿Necesita más información sobre algún procedimiento?
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            Nuestros especialistas están listos para resolver sus dudas y programar una consulta personalizada
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="#contacto" 
              className="bg-gradient-to-r from-[#0B2A4A] to-[#1B84FF] text-white py-4 px-8 rounded-lg hover:from-[#1B84FF] hover:to-[#0B2A4A] transition-all duration-300 cursor-pointer whitespace-nowrap inline-flex items-center justify-center"
            >
              <i className="ri-calendar-check-line mr-2"></i>
              Agendar Consulta
            </a>
            <a 
              href="tel:+523318648274" 
              className="border-2 border-[#0B2A4A] text-[#0B2A4A] py-4 px-8 rounded-lg hover:bg-[#0B2A4A] hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap inline-flex items-center justify-center"
            >
              <i className="ri-phone-line mr-2"></i>
              Llamar Ahora
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}